import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/services/common/common.service';
import { ServiceManagerService } from 'src/services/service-manager.service';

@Component({
  selector: 'app-help-us',
  templateUrl: './help-us.component.html',
  styleUrls: ['./help-us.component.scss']
})
export class HelpUsComponent implements OnInit {

  email: any;
  age: any;
  gender: any;
  city: any;
  sexuality: any;
  isInvalid: any;

  constructor(public commonService: CommonService,
    private serviceManager: ServiceManagerService) { }

  ngOnInit(): void {
  }

  /**
   * Navigate's to home
   */
  navToHome(){
    this.commonService.navigateToPage("/home")
  }

  /**
   * Saves changes
   */
  saveChanges(){

    if(this.email && !this.commonService.isValidEmail(this.email.trim()) ){
        this.isInvalid = "email"
        return
    }
    if(this.age  && !Number.isInteger(this.age)){
        this.isInvalid = "age"
        return
    }
    var body = {
      "email" : this.email,
      "age": this.age,
      "city": this.city,
      "sexuality": this.sexuality,
      "gender": this.gender,
      "user_id": localStorage.getItem("userId")
    }
    this.serviceManager.CallBackendServiceAPI("update_details", body).subscribe(
      (response: any) => {
        this.navToHome()
      }
    )
  }

}
